<template>
  <div
    :class="`${classes || ''} ${noMargin ? '' : 'bottom-offset3'} ${containerClasses}`"
  >
    <tr-typography
      class="block"
      variant="body"
    >
      {{ label }}
    </tr-typography>
    <tr-typography
      :class="`block vertical-offset1 ${onValueClick ? 'blue cursor-pointer' : ''}`"
      :color="valueColor"
      :variant="contentTextVariant || 'h4'"
    >
      <slot>
        <span @click="() => {onValueClick ? onValueClick() : null}">
          {{ value }}
        </span>
      </slot>
    </tr-typography>
  </div>
</template>

<script>
import TrTypography from './TrTypography.vue'

export default {
  name: 'TrReadOnlyTextField',
  components: {
    TrTypography
  },
  props: ['label', 'value', 'classes', 'noMargin',
    'onValueClick', 'contentTextVariant', 'valueColor',
    'dontUseColClasses'],
  computed: {
    containerClasses() {
      if (this.dontUseColClasses) {
        return '';
      }
      return 'col-lg-12 col-xs-12';
    }
  }
};
</script>
